var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icWrap",class:{ margTop: _vm.index === 1 }},[_c('div',{attrs:{"id":"captcha-element"}}),_c('div',{attrs:{"id":"buttonBtn"}})])}
var staticRenderFns = []

export { render, staticRenderFns }